import { render, staticRenderFns } from "./ModalHorizontalBarChart.vue?vue&type=template&id=a741fb5e&scoped=true"
import script from "./ModalHorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./ModalHorizontalBarChart.vue?vue&type=script&lang=js"
import style0 from "./ModalHorizontalBarChart.vue?vue&type=style&index=0&id=a741fb5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a741fb5e",
  null
  
)

export default component.exports